var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5167 13.08L17.0437 19.92H14.0283V17.16L21.5013 10.32L24.5167 13.08ZM28.9743 12.12C28.9743 12.48 28.581 12.84 28.1877 13.2L24.91 16.2L23.7301 15.12L27.1388 12L26.3522 11.28L25.4344 12.12L22.419 9.36L25.3033 6.84C25.5655 6.6 26.09 6.6 26.4833 6.84L28.3188 8.52C28.581 8.76 28.581 9.24 28.3188 9.6C28.0565 9.84 27.7943 10.08 27.7943 10.32C27.7943 10.56 28.0565 10.8 28.3188 11.04C28.7121 11.4 29.1054 11.76 28.9743 12.12ZM2.62211 21.6V2.4H11.7995V8.4H18.3547V10.2L20.9769 7.8V7.2L13.1105 0H2.62211C1.17995 0 0 1.08 0 2.4V21.6C0 22.92 1.17995 24 2.62211 24H18.3547C19.7969 24 20.9769 22.92 20.9769 21.6H2.62211ZM13.1105 18.12C12.8483 18.12 12.5861 18.24 12.455 18.24L11.7995 15.6H9.8329L7.07969 17.64L7.86632 14.4H5.89974L4.58869 20.4H6.55527L10.3573 17.28L11.144 20.04H12.455L13.1105 19.92V18.12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.34a8e4b1c8e2e4e2222e01ee88d114ff.svg";
export { ForwardRef as ReactComponent };